namespace GeniuzPOS.Product {
    export class CsSizeColumns {
        static columnsKey = 'Product.CsSize';
    }
}
